import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import LogoMarquee from '../components/common/LogoMarquee';
import '../styles/partners.css';

const PartnersPage = () => {
    const marqueeItems = [
        { name: 'TALTECH', image: "/assets/logos/taltech_logo.png" },
        { name: 'LoC', image: "/assets/logos/LoC_logo.jpg" },
        { name: 'EU HORIZON', image: "/assets/logos/ee_eu_logo.png" },
        { name: 'ETAG', image: "/assets/logos/etag_logo.png" },
        { name: 'BME', image: "/assets/logos/bme_logo.png" },
        { name: 'TALTECH', image: "/assets/logos/taltech_logo.png" },
        { name: 'LoC', image: "/assets/logos/LoC_logo.jpg" },
        { name: 'EU HORIZON', image: "/assets/logos/ee_eu_logo.png" },
        { name: 'ETAG', image: "/assets/logos/etag_logo.png" },
        { name: 'BME', image: "/assets/logos/bme_logo.png" },
    ];

    return (
        <div className="partners-wrapper">
            <SEO
                title="Partners & Support | Electrospinning Data Initiative"
                description="Explore our network of strategic, funding, and academic partners driving the future of open science in electrospinning."
            />

            {/* Hero Section - Aligned with Home */}
            <header className="hero-section text-center">
                <div className="container">
                    <h1 className="hero-heading">Partners & Support</h1>
                    <p className="hero-description mx-auto mb-0" style={{ maxWidth: '900px' }}>
                        Development of the <strong>Electrospinning Data Initiative</strong> is supported by the
                        <strong> Estonian Research Council</strong> under project <strong>PSG897</strong>.
                        Collaborating with world-class institutions and organizations to build
                        the world's most comprehensive open-access electrospinning database is gratefully acknowledged.
                    </p>
                </div>
            </header>

            {/* Rolling Panel (Logo Marquee) */}
            <LogoMarquee items={marqueeItems} />

            {/* CTA Section - Aligned with Home */}
            <section className="cta-section text-center">
                <div className="container">
                    <div className="cta-content mx-auto" style={{ maxWidth: '600px' }}>
                        <h2 className="text-white mb-2 fs-3">Join Our Mission</h2>
                        <p className="text-white-50 mb-3 fs-6">
                            Are you an institution or researcher interested in contributing to open science?
                            We're always looking for new partners.
                        </p>
                        <Link to="/contact" className="btn btn-light btn-md px-4 fw-bold text-primary">Partner With Us</Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PartnersPage;
